export const scrollToElementById = (parentElement: HTMLElement, elementId: string, offsetTop?: number) => {
    const section = window.document.getElementById(elementId);

    if (section) {
        const rect = section.getBoundingClientRect();
        const scrollTop = parentElement.scrollTop;
        const top = rect.top + scrollTop;

        window.scrollTo({
            top: top - (offsetTop || 0),
            behavior: "smooth"
        });
    }
};
export const scrollToElementById = (parentElement: HTMLElement, elementId: string, offsetTop?: number) => {
    const section = window.document.getElementById(elementId);

    if (section) {
        const rect = section.getBoundingClientRect();
        const scrollTop = parentElement.scrollTop;
        const top = rect.top + scrollTop;

        window.scrollTo({
            top: top - (offsetTop || 0),
            behavior: "smooth"
        });
    }
};
